module.exports = __webpack_public_path__ + "static/media/LogoGenoma.28023bda.png";